/* Routing */
import {Link} from "react-router-dom";
import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import FormProduct from "../../../forms/admin/FormProduct";

export default function ProductActions({apiProductList}) {

    const {newProductList, productInfos, setProductInfos,} = useData();
    const [values, setValues] = useState()
    const [showModalCreate, setShowModalCreate] = useState(false);

    useEffect(() => {
        setValues(newProductList)
    }, [values]);

    const handleAddProduct = (e) => {
        e.preventDefault()
        setProductInfos({})
        setShowModalCreate(true)
    }

    const handleRemoveModal = (e) => {
        if (e.target.classList.contains("modal-create", "product")) {
            setShowModalCreate(false)
        }
    };

    return (
        <>
            { showModalCreate &&
                <div className="modal modal-create product">
                    <FormProduct apiProductList={apiProductList} setShowModal={setShowModalCreate} legend="Informations générales" product={productInfos}/>
                </div>
            }
            <legend className="product-actions">
                <div className="cms-button">
                    <Link id="0" onClick={handleAddProduct}>
                        <button className="add-button"><i className="fa fa-plus"></i><span>Ajouter un produit</span>
                        </button>
                    </Link>
                </div>
            </legend>
        </>
    )
}